var React = require('react');

function ContentMonoSki (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Yb6lC3"},React.createElement("path",{"d":"M1.26.01c.63-.09,1.16.34,1.42.88.35.74.09,1.98.06,2.81-.1,2.23-.13,4.44-.04,6.66.04.93.36,2.95,0,3.72-.64,1.43-2.56.93-2.68-.63-.08-1.04.11-2.51.15-3.6.08-1.9.09-3.71,0-5.61-.04-.93-.36-2.61.04-3.4C.4.47.81.07,1.24.01h.02ZM.69,5.39v.97c.17,0,.34,0,.51.01,0-.32,0-.64.01-.96-.17,0-.35-.01-.52-.02ZM1.23,10.47v-2.17c-.17,0-.34,0-.51-.01,0,.72-.02,1.44-.03,2.16.18,0,.36.01.54.02ZM1.73,5.41v.97c.17,0,.34,0,.51.01,0-.32,0-.64.01-.96-.17,0-.35-.01-.52-.02ZM2.21,10.49v-2.17c-.17,0-.34,0-.51-.01,0,.72-.02,1.44-.03,2.16.18,0,.36.01.54.02Z"})));
}

ContentMonoSki.defaultProps = {"id":"Layer_1","version":"1.1","viewBox":"0 0 2.87 14.93"};

module.exports = ContentMonoSki;

ContentMonoSki.default = ContentMonoSki;
